import { debounce } from 'lodash';
import { useMemo, useRef, useState } from 'react';
import { FormGridType } from '@sierralabs/forms-core';
import { useApiPatch } from '@sierralabs/core-ui';
export function useFormGridConfig(config) {
    const grid = (config === null || config === void 0 ? void 0 : config.grid) || FormGridType.Vertical;
    const row = [FormGridType.Horizontal, FormGridType.Grid].includes(grid);
    const gridColumns = (config === null || config === void 0 ? void 0 : config.gridColumns) || 2;
    return { grid, row, gridColumns };
}
export function useFormUpsert() {
    const { data, isLoading, error, patch } = useApiPatch('forms');
    return {
        upsertedData: data,
        isUpserting: isLoading,
        upsertError: error,
        upsertFormData: patch
    };
}
/**
 * Debounce and accumulate object to allow multiple consecutive
 * set state calls without losing and overriding the previous state value.
 *
 * NOTE: taken from https://stackoverflow.com/a/66027298/7013346
 */
export function useAccumulate(delay = 10) {
    const [value, setValueState] = useState();
    const valueRef = useRef(value);
    const setValue = useMemo(() => {
        let merged;
        const callback = debounce(() => {
            // finally set the state and also set the new state value to ref
            setValueState((valueRef.current = merged));
            // reset merge object value
            merged = undefined;
        }, delay);
        return value => {
            // use ref as previous value
            const result = typeof value === 'function' ? value(valueRef.current) : value;
            // merge result with the merge object and assign the current
            // merge object to ref as this will be the new state value
            valueRef.current = merged = result && Object.assign({}, merged, result);
            callback();
        };
    }, [delay]);
    return [value, setValue];
}
//# sourceMappingURL=Form.hooks.js.map